import "./component7.scss";
import React from "react";
import { Link } from "react-router-dom";

const Component7 = () => {
  return (
    <section className="promo-banner promo-banner--delivery" aria-label="Доставка еды">
      <div className="promo-banner__bg" aria-hidden="true" />
      <div className="promo-banner__inner container">
        <div className="promo-banner__copy">
          <p className="section-label promo-banner__eyebrow">Кухня клуба</p>
          <h2 className="promo-banner__title">Доставка любимых блюд</h2>
          <p className="promo-banner__text">
            Соберите заказ из меню и оформите доставку звонком — без форм и
            регистрации.
          </p>
        </div>
        <Link className="promo-banner__btn" to="/delivery">
          Смотреть меню доставки
        </Link>
      </div>
    </section>
  );
};

export default Component7;
